export default __webpack_public_path__ + "static/img-art-pandas-profiling-4-0b5469cdb1acb7d853db36fbfae8346d.png";